import type { Template } from "@/types";

export const LA_07_H1_V6: Template[] = [
    {
        id: "la-07-h1v6-01",
        name: "LA 01 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 44, y: 62, width: 587, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 783, y: 36, width: 149, height: 231, rotation: 0, imageRotation: 0 },
            { id: "3", x: 940, y: 36, width: 149, height: 231, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1097, y: 36, width: 149, height: 231, rotation: 0, imageRotation: 0 },
            { id: "5", x: 783, y: 275, width: 149, height: 231, rotation: 0, imageRotation: 0 },
            { id: "6", x: 940, y: 275, width: 149, height: 231, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1097, y: 275, width: 149, height: 231, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-02",
        name: "LA 02 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 131, y: 56, width: 415, height: 246, rotation: 0, imageRotation: 0 },
            { id: "2", x: 790, y: 56, width: 286, height: 428, rotation: 0, imageRotation: 0 },
            { id: "3", x: 131, y: 309, width: 133, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 272, y: 309, width: 133, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 413, y: 309, width: 133, height: 174, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1084, y: 56, width: 149, height: 210, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1084, y: 274, width: 149, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-03",
        name: "LA 03 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 115, y: 56, width: 446, height: 273, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 115, y: 337, width: 106, height: 148, rotation: 0, imageRotation: 0 },
            { id: "3", x: 229, y: 337, width: 106, height: 148, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 337, width: 105, height: 148, rotation: 0, imageRotation: 0 },
            { id: "5", x: 456, y: 337, width: 105, height: 148, rotation: 0, imageRotation: 0 },
            { id: "6", x: 763, y: 69, width: 248, height: 403, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 69, width: 248, height: 403, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-04",
        name: "LA 04 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 169, y: 56, width: 331, height: 199, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 169, y: 263, width: 162, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 339, y: 263, width: 162, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 802, y: 56, width: 298, height: 428, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1108, y: 56, width: 102, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1108, y: 202, width: 102, height: 137, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1108, y: 347, width: 102, height: 137, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-05",
        name: "LA 05 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 169, y: 56, width: 331, height: 199, rotation: 0, imageRotation: 0 },
            { id: "2", x: 169, y: 263, width: 162, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 339, y: 263, width: 162, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 844, y: 56, width: 167, height: 211, rotation: 0, imageRotation: 0 },
            { id: "5", x: 844, y: 275, width: 167, height: 210, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 56, width: 166, height: 211, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 275, width: 166, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-06",
        name: "LA 06 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 74, y: 84, width: 529, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 842, y: 40, width: 110, height: 149, rotation: 0, imageRotation: 0 },
            { id: "3", x: 842, y: 197, width: 110, height: 149, rotation: 0, imageRotation: 0 },
            { id: "4", x: 842, y: 354, width: 110, height: 148, rotation: 0, imageRotation: 0 },
            { id: "5", x: 960, y: 40, width: 226, height: 306, rotation: 0, imageRotation: 0 },
            { id: "6", x: 960, y: 354, width: 109, height: 148, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1077, y: 354, width: 109, height: 148, rotation: 0, imageRotation: 0 }            
        ],
    },

    {
        id: "la-07-h1v6-07",
        name: "LA 07 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 74, y: 84, width: 529, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 842, y: 39, width: 110, height: 149, rotation: 0, imageRotation: 0 },
            { id: "3", x: 842, y: 196, width: 227, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 960, y: 39, width: 109, height: 149, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1077, y: 39, width: 109, height: 149, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1077, y: 196, width: 109, height: 149, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1077, y: 353, width: 109, height: 148, rotation: 0, imageRotation: 0 }          
        ],
    },

    {
        id: "la-07-h1v6-08",
        name: "LA 08 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 113, y: 78, width: 442, height: 254, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 113, y: 339, width: 82, height: 123, rotation: 0, imageRotation: 0 },
            { id: "3", x: 203, y: 339, width: 82, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 293, y: 339, width: 82, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 383, y: 339, width: 82, height: 123, rotation: 0, imageRotation: 0 },
            { id: "6", x: 473, y: 339, width: 82, height: 123, rotation: 0, imageRotation: 0 },
            { id: "7", x: 820, y: 0, width: 389, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-09",
        name: "LA 09 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 54, width: 262, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 54, width: 261, height: 435, rotation: 0, imageRotation: 0 },                   
            { id: "3", x: 539, y: 54, width: 126, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 539, y: 276, width: 126, height: 213, rotation: 0, imageRotation: 0 },
            { id: "5", x: 673, y: 54, width: 545, height: 435, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1226, y: 54, width: 126, height: 213, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1226, y: 276, width: 126, height: 213, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-10",
        name: "LA 10 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 54, width: 262, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 54, width: 261, height: 435, rotation: 0, imageRotation: 0 },
            { id: "3", x: 539, y: 54, width: 275, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 539, y: 276, width: 134, height: 213, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 276, width: 133, height: 213, rotation: 0, imageRotation: 0 },
            { id: "6", x: 822, y: 54, width: 261, height: 435, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1091, y: 54, width: 261, height: 435, rotation: 0, imageRotation: 0 }
        ],
    }
];